import 'brace/ext/language_tools';
import 'brace/ext/searchbox';
import 'brace/mode/python';
import 'brace/mode/sql';
import React from 'react';
import AceEditor from 'react-ace';

import {CustomComponentEditorProps} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';

import {PYTHON_STARTER_CODE} from './StarterCode';

export type CodeEditorMode = 'python' | 'sql';

const DEFAULT_VALUE: Record<CodeEditorMode, string> = {
  python: PYTHON_STARTER_CODE,
  sql: '',
};

interface UserDefinedFunctionEditorProps extends CustomComponentEditorProps {
  fieldName: string;
  mode?: CodeEditorMode;
}

export default function UserDefinedFunctionEditor({
  config: fullConfig,
  onChangeConfig,
  disabled,
  fieldName,
  mode = 'python',
}: UserDefinedFunctionEditorProps): JSX.Element {
  const value = (fullConfig[fieldName] as string | null) ?? DEFAULT_VALUE[mode];

  const handleChange = (newValue: string): void => {
    onChangeConfig(fullConfig, [fieldName], newValue);
  };

  return (
    <AceEditor
      value={value}
      onChange={handleChange}
      mode={mode}
      readOnly={disabled}
      showGutter={true}
      showPrintMargin={false}
      minLines={20}
      wrapEnabled={true}
      // TODO(BNCH-123236): Make height and width responsive
      width="500px"
      height="600px"
    />
  );
}
